import { ArrowForward } from "@mui/icons-material";
import { ReactComponent as CheckCircleOutline } from '../../assets/check2-circle.svg';
import { Card, CardActionArea, CardActions, CardContent, CardMedia, Grid, Typography } from "@mui/material";
import { Button } from "react-bootstrap";
import referralEnrolmentImage from '../../assets/hacker51.png';
import taxShieldImage from '../../assets/optima-tax-shield.png';
import awards from '../../assets/Accreditations-Awards.png';
import useProfileStore from "../../store/ProfileStore";
import { useState } from "react";
import { EConsentModal } from "../../Common/EConsentModal";

type Props = {
    onUpgrade: () => void;
} 
const ReferralOtsEntryForm = ({onUpgrade}: Props) => {
    const { eConsent } = useProfileStore();
    const [showConsentModal, setShowContentModal] = useState(false);

    const onClickHandler = () => {
        console.log(eConsent);
        if(eConsent){
            onUpgrade();
        }else {
            setShowContentModal(true);
        }
    }

    const onAgreeHandler = () => {
        setShowContentModal(false);
        onUpgrade();
    }

    const onConsentModalCloseHandler = () => {
        setShowContentModal(false);
    }

    return (
        <>
        <Card sx={{width: '100%', height: '90vh', p: 0, m:0, borderRadius: 0}}>
            <CardActionArea sx={{position: 'relative'}}>
                <CardMedia component="img" src="/assets/BG-protect-splash.png" sx={{position: 'absolute', top: 0, right: 0, bottom:0}} />
                <CardContent sx={{position: 'absolute', backgroundColor: 'transparent', top: 50, left: 5}}>
                <Grid container sx={{marginInlineStart: '2rem'}}>
                    <Grid item md={5} xs={12}>
                    <img src={taxShieldImage} style={{width:'50%', marginBottom: '1rem'}}/>
                    <Typography variant="h4" sx={{fontWeight: 700}}>Tax ID Theft victimizes millions <br />of Americans each year.</Typography>
                    <Typography variant="h4" sx={{fontWeight: 700, color: '#1D89D2'}}>Let us keep you safe for FREE.</Typography>   
                    <Typography variant="body1" sx={{mt:3, mb:2}}>Get Optima’s best-in-class <b>Tax ID Theft <br />Alert and Monitoring</b> service.</Typography>
                    <Typography variant="body2" className="mt-1" sx={{textTransform: 'uppercase', fontWeight: '600', fontSize: '14px'}}>Additional Benefits:</Typography>
                    <Typography variant="body2" className="mt-1"> <CheckCircleOutline className="me-1"/> Monthly Tax Report</Typography>
                    <Typography variant="body2" className="mt-1"> <CheckCircleOutline className="me-1"/> IRS Balance Tracking</Typography>
                    <Typography variant="body2" className="mt-1"> <CheckCircleOutline className="me-1"/> IRS Notice Analysis</Typography>
                    <CardActions sx={{padding: 0}}>
                    <Button className="plan-fill-button mt-3" onClick={onClickHandler}>Get Protected <ArrowForward /> </Button>
                    </CardActions>
                    <Typography className="fs-10px mt-3" sx={{color: '#667085'}}>Please review Protection Agreement for details and limitations.</Typography>
                    <img src={awards} style={{width:'70%', marginTop: '1.2rem'}}/>
                    </Grid>
                    <Grid item md={7} className="no-display-mobile">
                        <img src={referralEnrolmentImage} style={{width:'70%'}}/>
                        <Typography variant="h5"  className="mt-3">Get Protected & Stay Protected for <b>FREE</b></Typography>
                    </Grid>
                </Grid>
                </CardContent>
            </CardActionArea>
        </Card>
        {showConsentModal && <EConsentModal onAgree={onAgreeHandler} onClose={onConsentModalCloseHandler} open={showConsentModal} /> }
        </>
    );
}

export default ReferralOtsEntryForm;